import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import { BehaviorSubject, switchMap } from 'rxjs';

import { baseEnvironment } from '../../../../environments/environment.base';
import { FreyaCommonModule } from '../../../freya-common/freya-common.module';

import { quickJsActions } from '../../../quickjs/quickjs.actions';
import { quickjsFeature } from '../../../quickjs/quickjs.feature';

import { CalculatorFieldComponent } from './mr-calculator-fields/mr-calculator-fields.component';

export type CalculatorSlot = 'main' | 'customer';

@Component({
  selector: 'app-mr-calculator',
  standalone: true,
  imports: [
    CommonModule,
    FreyaCommonModule,
    CalculatorFieldComponent,
  ],
  templateUrl: './mr-calculator.component.html',
  styleUrls: [
    './mr-calculator.component.scss',
    '../../job-financials/document-container-style.scss',
  ],
})
export class MrCalculatorComponent {

  public isDev = baseEnvironment.environment === 'local';

  public actions = quickJsActions;

  private slot$ = new BehaviorSubject<CalculatorSlot>('main');

  @Input() set slot(value: CalculatorSlot) {
    this.slot$.next(value ?? 'main');
  }

  @Input() showHeader = true;

  public viewModel$ = this.slot$.pipe(
    switchMap((slot) => this.store.select(createSelector({
      elements: slot === 'customer'
        ? quickjsFeature.selectCustomerElements
        : quickjsFeature.selectElements,
      scriptLoaded: quickjsFeature.selectScriptLoaded,
      scriptError: quickjsFeature.selectScriptError,
    }))),
  );

  constructor(
    public store: Store,
  ) {}

  trackByKey(index: number, item: any): string {
    return item.key || index;
  }

}
